import { ThemeEvents } from '@theme/events';
import { prefersReducedMotion, viewTransition } from '@theme/utilities';

let scrollRequestId = 0;
const COLLECTION_SCROLL_MARGIN = 50;

function getHeaderOffset() {
  const bodyStyles = getComputedStyle(document.body);
  const headerGroupHeight = parseFloat(bodyStyles.getPropertyValue('--header-group-height'));

  if (!Number.isNaN(headerGroupHeight)) {
    return headerGroupHeight;
  }

  const headerGroup = document.querySelector('#header-group');
  return headerGroup instanceof HTMLElement ? headerGroup.getBoundingClientRect().height : 0;
}

function getScrollTarget(resultsList) {
  if (resultsList.matches('.product-grid-container')) {
    return resultsList;
  }

  return resultsList.closest('.product-grid-container') || resultsList.querySelector('.product-grid-container') || resultsList;
}

function getCurrentResultsList(sectionId, fallback) {
  return (
    Array.from(document.querySelectorAll('results-list')).find((resultsList) => {
      return resultsList.getAttribute('section-id') === sectionId;
    }) || fallback
  );
}

async function waitForCollectionUpdate(resultsList) {
  const target = getScrollTarget(resultsList);

  await new Promise((resolve) => {
    let isResolved = false;

    const finish = () => {
      if (isResolved) return;
      isResolved = true;
      observer.disconnect();
      window.clearTimeout(timeout);
      requestAnimationFrame(resolve);
    };

    const observer = new MutationObserver(finish);
    const timeout = window.setTimeout(finish, 2500);

    observer.observe(target, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    requestAnimationFrame(async () => {
      if (!viewTransition.current) return;

      await viewTransition.current.catch(() => {});
      finish();
    });
  });
}

async function scrollToCollectionResults(event) {
  if (!(event.target instanceof Element)) return;

  const resultsList = event.target.closest('results-list');
  if (!(resultsList instanceof HTMLElement)) return;

  const currentRequestId = ++scrollRequestId;
  const sectionId = resultsList.getAttribute('section-id');

  await waitForCollectionUpdate(resultsList);

  if (currentRequestId !== scrollRequestId || !sectionId) return;

  const currentResultsList = getCurrentResultsList(sectionId, resultsList);
  if (!(currentResultsList instanceof HTMLElement) || !currentResultsList.isConnected) return;

  const target = getScrollTarget(currentResultsList);
  const top = target.getBoundingClientRect().top + window.scrollY - getHeaderOffset() - COLLECTION_SCROLL_MARGIN;

  window.scrollTo({
    top: Math.max(top, 0),
    behavior: prefersReducedMotion() ? 'instant' : 'smooth',
  });
}

document.addEventListener(ThemeEvents.FilterUpdate, scrollToCollectionResults);
